// extracted by mini-css-extract-plugin
export var cardContainer = "_qf-0";
export var cardHeader = "_qf-2";
export var collapsedState = "_qf-3";
export var dragHandle = "_qf-5";
export var dragHandleIcon = "_qf-6";
export var dragging = "_qf-1";
export var titleArea = "_qf-4";